(function ($) {
  Drupal.behaviors.anchoredMenuV1 = {
    attach: function (context) {
      var $sections = $('.anchored-item', context);
      var $nav = $('.js-anchored-menu .menu', context);
      var navHeight = $nav.height();
      var $navLinks = $nav.find('a');
      var $mppMenu = $('.js-menu-mpp', context);

      if ($mppMenu.length > 0) {
        $navLinks.addClass('js-mpp-menu');
      }

      $navLinks.first().addClass('active');
      $(window).on(
        'scroll',
        _.throttle(function () {
          var curPos = $(this).scrollTop();

          $sections.each(function () {
            var $this = $(this);
            var top = $this.offset().top - (navHeight + 254);
            var bottom = top + $this.height();
            var $eachAnchor = $(
              'a[href="' + window.location.pathname + '#' + $this.attr('id') + '"]',
              context
            );

            if (curPos >= top && curPos <= bottom) {
              $navLinks.removeClass('active');
              $sections.removeClass('active');
              $this.addClass('active');
              $nav.find($eachAnchor).addClass('active');
            }
          });
        }, 500)
      );
      $navLinks.once().on('click', function (context) {
        var $el = $(this);
        var url = $el.attr('href');
        var urlHash = url.split('#');
        var id = urlHash[1];

        $('html, body').animate(
          {
            scrollTop: $('#' + id).offset().top - (navHeight + 54)
          },
          500
        );

        return false;
      });
    }
  };
})(jQuery);
